import React from 'react';
import classNames from 'classnames';
import styles from './Card.module.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  className,
  hover = false,
  padding = 'md',
  onClick,
}) => {
  return (
    <div
      className={classNames(
        styles.card,
        styles[`padding-${padding}`],
        {
          [styles.hover]: hover,
          [styles.clickable]: onClick,
        },
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;